import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { readStyle } from "./indicatorUtils";

export const createAD = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const adS = readStyle(styles, "ad", "#2196F3");

  return {
    name: "ad",
    shortName: "A/D",
    calcParams: [] as number[],
    series: "normal" as const,
    figures: [{ key: "ad", title: "A/D: ", type: "line" }],
    styles: {
      lines: [klineLineStyle(adS.color, 2, lineStyleToKLine(adS.style))],
    },
    regenerateFigures: () => [{ key: "ad", title: "A/D: ", type: "line" }],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{ ad?: number }> = new Array(n);
      let ad = 0;

      for (let i = 0; i < n; i++) {
        const { high, low, close } = dataList[i]!;
        const vol = dataList[i]!.volume ?? 0;
        let mfm = 0;
        if (high !== low) {
          mfm = ((close - low) - (high - close)) / (high - low);
        }
        ad += mfm * vol;
        results[i] = { ad };
      }

      return results;
    },
  };
};
